<template>
    <app-modal-view class="has-overflow" @close="closeModal">
        <template #header>
            <slot name="header-title">
                <p class="is-size-5 has-text-weight-bold has-text-centered">
                    {{ $t('Community.management_title') }}
                </p>
            </slot>
        </template>
        <template #body>
            <div class="columns" style="height: 15rem">
                <div class="column is-6">
                    <app-dropdown-selector
                        :options="activityFolders"
                        :default-option="defaultFolder"
                        :loading-options="loadingFolders"
                        @change="selectFolder"
                    >
                        <template #control-label>
                            <p v-t="'Labels.save_in'" class="label" />
                        </template>
                    </app-dropdown-selector>
                </div>
                <div class="column is-6">
                    <app-dropdown-selector
                        :options="adminCommunities"
                        :default-option="community"
                        :loading-options="loadingCommunities"
                        @change="fetchCommunity"
                    >
                        <template #control-label>
                            <p v-t="'Labels.move_to'" class="label" />
                        </template>
                    </app-dropdown-selector>
                </div>
            </div>
        </template>
        <template #footer>
            <div
                class="buttons is-flex is-justify-content-center"
                style="width: 100%"
            >
                <button
                    v-t="'Buttons.close'"
                    class="button is-dark"
                    @click="closeModal"
                ></button>
                <button
                    v-t="'Buttons.save_and_close'"
                    :class="{ 'is-loading': loading }"
                    class="button is-primary"
                    @click="save"
                ></button>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import AppDropdownSelector from '@/components/AppDropdownSelector';
import _ from 'underscore';
import { fetchItem } from '@/services/API';
export default {
    components: {
        AppModalView,
        AppDropdownSelector,
    },
    props: {
        activity: {
            type: Object,
            default: () => {},
            required: true,
        },
    },
    data() {
        return {
            loadingFolders: false,
            loadingCommunities: false,
            activityFolders: [],
            selectedCommunity: undefined,
            selectedFolder: undefined,
            loading: false,
        };
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        adminCommunities() {
            return this.$store.getters.adminCommunities;
        },
        currentFolder() {
            return _.findWhere(this.activityFolders, {
                _id: this.$store.state.activeFolder,
            });
        },
        defaultFolder() {
            if (
                this.selectedCommunity &&
                this.community._id != this.selectedCommunity._id
            ) {
                console.log('cjanging default folder');
                return this.activityFolders[0];
            } else {
                return this.currentFolder;
            }
        },
    },
    mounted() {
        this.loadingCommunities = true;
        this.loadingFolders = true;
        this.$store.dispatch('fetchMyCommunities').then(() => {
            this.loadingCommunities = false;
            this.loadingFolders = false;
            this.activityFolders = this.$store.getters.communityActivityFolders;
        });
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        selectFolder(folder) {
            this.selectedFolder = folder;
        },
        async save() {
            this.$store.dispatch('moveCommunityActivity', {
                activity: this.activity,
                folder: this.selectedFolder || this.defaultFolder,
                community: this.selectedCommunity || this.community,
            });
            this.closeModal();
        },
        async fetchCommunity(community) {
            this.selectedCommunity = community;
            this.loadingFolders = true;
            let response = await fetchItem('community', community._id).finally(
                () => {
                    this.loadingFolders = false;
                }
            );
            this.activityFolders = response.data.activityFolders;
        },
    },
};
</script>

<style scoped lang="css"></style>
